export default function FrameOverlay() {
  return (
    <div className="absolute inset-0 z-10 pointer-events-none">
      <div className="absolute inset-0 border-[4px] border-accent-500/50" />
      <div className="absolute inset-[4px] border-[2px] border-accent-500/25" />
      <div className="absolute top-[4px] left-[4px] w-5 h-5 border-t-[3px] border-l-[3px] border-accent-500" />
      <div className="absolute top-[4px] right-[4px] w-5 h-5 border-t-[3px] border-r-[3px] border-accent-500" />
      <div className="absolute bottom-[4px] left-[4px] w-5 h-5 border-b-[3px] border-l-[3px] border-accent-500" />
      <div className="absolute bottom-[4px] right-[4px] w-5 h-5 border-b-[3px] border-r-[3px] border-accent-500" />
    </div>
  );
}